import { useEntity, MissingAnnotationEmptyState } from '@backstage/plugin-catalog-react';
import React, { useState } from 'react';
import { useBitriseBuildWorkflows } from '../../hooks/useBitriseBuildWorkflows.esm.js';
import { BitriseBuildsTable } from '../BitriseBuildsTableComponent/BitriseBuildsTableComponent.esm.js';
import { SelectComponent } from '../Select/Select.esm.js';
import { Page, Content, ContentHeader } from '@backstage/core-components';

const BITRISE_APP_ANNOTATION = "bitrise.io/app";
const isBitriseAvailable = (entity) => Boolean(entity.metadata.annotations?.[BITRISE_APP_ANNOTATION]);
const BitriseBuildsComponent = () => {
  const { entity } = useEntity();
  const appName = entity.metadata.annotations?.[BITRISE_APP_ANNOTATION];
  const [selectedWorkflow, setSelectedWorkflow] = useState(" ");
  const workflows = useBitriseBuildWorkflows(appName);
  const onSelectedWorkflowChanged = (workflow) => {
    setSelectedWorkflow(workflow);
  };
  const getSelectionItems = (items) => {
    const noWorkflowSpecified = { label: "All workflows", value: " " };
    return items.value ? [
      noWorkflowSpecified,
      ...items.value.map((item) => {
        return { label: item, value: item };
      })
    ] : [];
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !appName ? /* @__PURE__ */ React.createElement(MissingAnnotationEmptyState, { annotation: BITRISE_APP_ANNOTATION }) : /* @__PURE__ */ React.createElement(Page, { themeId: "tool" }, /* @__PURE__ */ React.createElement(Content, { noPadding: true }, /* @__PURE__ */ React.createElement(ContentHeader, { title: appName }, /* @__PURE__ */ React.createElement(
    SelectComponent,
    {
      value: selectedWorkflow,
      onChange: (workflow) => onSelectedWorkflowChanged(workflow),
      label: "Workflow",
      items: getSelectionItems(workflows)
    }
  )), /* @__PURE__ */ React.createElement(
    BitriseBuildsTable,
    {
      appName,
      workflow: selectedWorkflow,
      error: workflows.error
    }
  ))));
};

export { BITRISE_APP_ANNOTATION, BitriseBuildsComponent, isBitriseAvailable };
//# sourceMappingURL=BitriseBuildsComponent.esm.js.map
